const ID = /^[A-Za-z0-9_-]+$/;

function parseUrl(input: string) {
  if (!/^https?:\/\/\S+$/i.test(input)) {
    return;
  }
  try {
    return new URL(input);
  } catch {
    return;
  }
}

function seconds(value: string | null) {
  if (!value) {
    return;
  }
  const match = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
  if (!match) {
    return;
  }
  const total = Number(match[1] || 0) * 3600 + Number(match[2] || 0) * 60 + Number(match[3] || 0);
  return total || undefined;
}

function youtubeSrc(url: URL) {
  const host = url.hostname.replace(/^(www|m)\./, '');
  const parts = url.pathname.split('/').filter(Boolean);
  let id: string | undefined;
  if (host === 'youtu.be') {
    id = parts[0];
  } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    if (parts[0] === 'watch') {
      id = url.searchParams.get('v') || undefined;
    } else if (['embed', 'shorts', 'live'].includes(parts[0])) {
      id = parts[1];
    }
  }
  if (id === 'videoseries') {
    const list = url.searchParams.get('list');
    return list && ID.test(list)
      ? `https://www.youtube.com/embed/videoseries?list=${list}`
      : undefined;
  }
  if (!id || !ID.test(id)) {
    return;
  }
  const start = seconds(url.searchParams.get('t') || url.searchParams.get('start'));
  return `https://www.youtube.com/embed/${id}${start ? `?start=${start}` : ''}`;
}

function vimeoSrc(url: URL) {
  const host = url.hostname.replace(/^www\./, '');
  const parts = url.pathname.split('/').filter(Boolean);
  let id: string | undefined;
  let hash: string | undefined;
  if (host === 'vimeo.com') {
    const videoIndex = parts.findIndex((part) => part === 'video' || part === 'videos');
    const isCollection = ['showcase', 'album'].includes(parts[0]);
    if (videoIndex >= 0) {
      id = parts[videoIndex + 1];
    } else if (!isCollection) {
      const index = parts.findIndex((part) => /^\d+$/.test(part));
      if (index >= 0) {
        id = parts[index];
        hash = parts[index + 1];
      }
    }
  } else if (host === 'player.vimeo.com' && parts[0] === 'video') {
    id = parts[1];
    hash = url.searchParams.get('h') || undefined;
  }
  if (!id || !/^\d+$/.test(id)) {
    return;
  }
  const h = hash && /^[0-9a-f]+$/i.test(hash) ? `?h=${hash}` : '';
  return `https://player.vimeo.com/video/${id}${h}`;
}

function loomSrc(url: URL) {
  const host = url.hostname.replace(/^www\./, '');
  const parts = url.pathname.split('/').filter(Boolean);
  if (host !== 'loom.com' || !['share', 'embed'].includes(parts[0]) || !parts[1]) {
    return;
  }
  return ID.test(parts[1]) ? `https://www.loom.com/embed/${parts[1]}` : undefined;
}

export function isBareLink(input: string) {
  return !!parseUrl(input.trim());
}

export function linkToEmbed(input: string) {
  const url = parseUrl(input.trim());
  if (!url) {
    return;
  }
  const src = youtubeSrc(url) || vimeoSrc(url) || loomSrc(url);
  if (!src) {
    return;
  }
  return `<div style="position:relative;padding-top:56.25%"><iframe src="${src}" style="position:absolute;inset:0;width:100%;height:100%;border:0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" allowfullscreen></iframe></div>`;
}
